import React from 'react';
import CheckboxRadioIcon from './CheckboxRadioIcon.jsx';
import CheckboxLike from './CheckboxLike.jsx';

const CheckboxIcon = (props) => {
  return <CheckboxLike { ...props } component={ CheckboxRadioIcon }/>;
};

export default CheckboxIcon;
